import { render } from "./uploadPicture.vue?vue&type=template&id=7ce0938a&scoped=true"
import script from "./uploadPicture.vue?vue&type=script&lang=js"
export * from "./uploadPicture.vue?vue&type=script&lang=js"

import "./uploadPicture.vue?vue&type=style&index=0&id=7ce0938a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce0938a"]])

export default __exports__